import SOVSetupPage from "./SOVSetup/pages/SOVSetupPage";
import "./SOVSetup/styles/sovSetup.scss";

interface ContractAmount {
  amount: number;
  currency?: { symbol: string };
}

interface Lender {
  companyName?: string;
}

interface SOVSetupProps {
  contractAmount?: ContractAmount;
  lender?: Lender;
  isActive: boolean;
  versionId?: string;
  projectId?: string;
  isStandalone?: boolean;
}

export default function SOVSetup({
  contractAmount = undefined,
  lender = undefined,
  isActive,
  versionId = undefined,
  projectId = undefined,
  isStandalone = false,
}: SOVSetupProps) {
  if (!isActive) return null;

  return (
    <div className="sovSection" id="sec-sov-setup">
      <SOVSetupPage
        contractAmount={contractAmount}
        lender={lender}
        versionId={versionId}
        projectId={projectId}
        isStandalone={isStandalone}
      />
    </div>
  );
}
